<div class="loader vers-section" [hidden]="pageStatus != STATUS_LOADING"> 
  <div class="dimmed_outset">
        <core-title-section [title]="'ARTWORK v. . . . <small>(# .  .  . )</small>'"></core-title-section>
  </div>
  <div class="dimmed dimmed_main" >
  <div class="dimmed_nav"></div>
  <div class="dimmed_content">
        <div class="dimmed_flex">
          <span class="dimmed_tag"></span> 
          <span class="dimmed_tag"></span>
          <span class="dimmed_tag"></span>
        </div>
    </div>
  </div>
</div>
<div class="app-wrapper" *ngIf="pageStatus == STATUS_DONE">
  <nav class="tab_navigation">
    <!-- &nbsp; -->
  </nav>
  <section class="main-content version-details-section">
    <div class="content-info-main">
      <div class="layout-main">
        <!-- here will load each part of version details -->
        <router-outlet></router-outlet>
      </div>
    </div>
  </section>
</div>
<core-helpers-box-http-error
    *ngIf="pageStatus == STATUS_NOT_ALLOWED && statusHeader == STATUS_NOT_ALLOWED"
    [code]="403"
    [message]="'Not allowed.'"
></core-helpers-box-http-error>

<core-helpers-box-http-error
    *ngIf="pageStatus == STATUS_NOT_FOUND"
    [code]="404"
    [message]="'Not found.'"
></core-helpers-box-http-error>

<core-helpers-box-http-error
    *ngIf="pageStatus == STATUS_ERROR"
    [code]="500"
    [message]="'Error.'"
></core-helpers-box-http-error>